import React,{useState, useEffect, useRef} from 'react';

export default function StreamPowerExplainerVideoComponent(props:any) {
    console.log('props.powerType', props.powerType, props.previewVideoUri);
    return(
        <video 
            controls
            // autoPlay
            style={props.style}
            disablePictureInPicture
            controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
            // src={EXPLAINER_VIDEO_DICT[props.powerType]}
            src={props.previewVideoUri}
        />
    );
    
}
